import React, { useContext } from "react";
import { Grid, Skeleton } from "@mui/material";
import { UserContext } from "../../contexts/userContext";
import { MARKETPLACE } from "../../utils/constants";

const FiltersHeaderSkeleton = ({ isOwnFleet = false }: { isOwnFleet?: boolean }) => {
  const {
    currentUser: { entity },
  } = useContext(UserContext);

  const showMerchant = entity === MARKETPLACE;
  const showCarrier = !isOwnFleet;

  return (
    <Grid container className="m-t-10" display={"flex"} spacing={2}>
      {/* Desde */}
      <Grid item xs={12} md={2}>
        <Skeleton variant="rectangular" height={40} />
      </Grid>
      {/* Hasta */}
      <Grid item xs={12} md={2}>
        <Skeleton variant="rectangular" height={40} />
      </Grid>
      {/* Merchant */}
      {showMerchant && (
        <Grid item xs={12} md={6} lg={showCarrier ? 2.5 : 3.75}>
          <Skeleton variant="rectangular" height={40} />
        </Grid>
      )}
      {/* Carrier */}
      {showCarrier && (
        <Grid item xs={12} md={6} lg={2.5}>
          <Skeleton variant="rectangular" height={40} />
        </Grid>
      )}
      {/* Search */}
      <Grid item xs={12} md={6} lg={showCarrier ? 3 : 4.25} className="search-min-width">
        <Skeleton variant="rectangular" height={40} />
      </Grid>
      {/* Status */}
      <Grid item xs={12} md={6} lg={3}>
        <Skeleton variant="rectangular" height={40} />
      </Grid>
      {/* Limpiar filtros */}
      <Grid item xs={12} md={6} lg={2}>
        <Skeleton variant="rectangular" height={40} />
      </Grid>
    </Grid>
  );
};

export default FiltersHeaderSkeleton;
